import { render, staticRenderFns } from "./MoonGlobalParameterValue.vue?vue&type=template&id=4f84804a&"
import script from "./MoonGlobalParameterValue.vue?vue&type=script&lang=ts&"
export * from "./MoonGlobalParameterValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports